import { render, staticRenderFns } from "./UpdatedChanges.vue?vue&type=template&id=f4d4aafa&"
import script from "./UpdatedChanges.vue?vue&type=script&lang=js&"
export * from "./UpdatedChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports